import { createComponent } from "@helpers/admin";
import DomainNamePricingTableComponent from "@template/blocks/domain/DomainNamePricingTable";

export const DomainNamePricingTable = createComponent({
  label: "Pricing Table",
  component: DomainNamePricingTableComponent,
  fields: {
    title: {
      label: "Title",
      type: "textarea",
    },
    button: {
      label: "Button",
      type: "button",
    },
  },
});
